import { status } from '../../helpers'

const getProfileStoreDefaultState = () => {
  return {
    user: {},
    loadUserProfile: status.INITIALIZED,
    updatigUserProfile: false,
    IDPProfile: {},
    existingIDPProfile: false,
    updatingIDPSettings: false
  }
}

export default getProfileStoreDefaultState
